import styled from 'styled-components';
import { breakpoints, colors } from '../../../theme';
import { HEADER_HEIGHT } from '../../../theme/constants';
import { Link } from 'react-router-dom';

export const HeaderContainer = styled.header<{ $isHidden: boolean }>`
  width: 100%;
  background-color: var(--color-background);
  padding: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  height: ${HEADER_HEIGHT.desktop};
  z-index: 1000;
  transition: transform 0.3s ease-in-out, height 0.3s ease-in-out;
  transform: ${(props) => (props.$isHidden ? 'translateY(-100%)' : 'translateY(0)')};

  @media (max-width: ${breakpoints.tablet}) {
    padding: 0.75rem 1rem;
    height: ${HEADER_HEIGHT.tablet};
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LogoImage = styled.img`
  height: 130px;
  width: auto;

  @media (max-width: ${breakpoints.tablet}) {
    height: 70px;
  }
`;

export const Nav = styled.nav<{ $isMenuOpen: boolean }>`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: ${breakpoints.tablet}) {
    display: ${(props) => (props.$isMenuOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: var(--color-background);
    padding: 1rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    animation: fadeIn 0.3s ease-in-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const NavLink = styled(Link)<{ $primary?: boolean; $isActive?: boolean }>`
  color: ${(props) => (props.$isActive ? '#fff' : colors.sealBrown.replace('ff', ''))};
  background-color: ${(props) => (props.$isActive ? 'var(--color-secondary)' : 'transparent')};
  font-size: 1rem;
  text-decoration: none;
  font-weight: 200;
  padding: 0.6rem 0.8rem;
  border-radius: 4px;
  transition: background-color 0.3s, color 0.3s;
  white-space: nowrap; /* Ensures the text does not wrap into multiple lines */

  &:focus-visible {
    outline: 3px solid var(--color-highlight);
    outline-offset: 2px;
  }

  &:hover {
    color: #fff;
    background-color: var(--color-secondary);
  }

  ${(props) =>
    props.$primary &&
    `
    padding: 0.6rem 1rem;
    background-color: ${colors.russet};
    color: #fff;
    border-radius: 5px;

    &:hover {
      background-color: ${colors.russet};
    }
  `}
`;


export const NavLinkGetInvolved = styled(Link)<{ $primary?: boolean; $isActive?: boolean }>`
  color: ${(props) => (props.$isActive ? '#fff' : colors.sealBrown.replace('ff', ''))};
  background-color: ${(props) => (props.$isActive ? 'var(--color-secondary)' : 'transparent')};
  font-size: 1rem;
  text-decoration: none;
  font-weight: 500;
  padding: 0.6rem 0.8rem;
  border-radius: 4px;
  transition: background-color 0.3s, color 0.3s;

  &:focus-visible {
    outline: 3px solid var(--color-highlight);
  }

  &:hover {
    color: #fff;
    background-color: var(--color-secondary);
  }

  ${(props) =>
    props.$isActive &&
    `
    background-color: ${colors.cafNoir};
    color: #fff;
  `}
`;

export const MenuIcon = styled.div`
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--color-text);

  @media (min-width: ${breakpoints.tablet}) {
    display: none;
  }

  @media (max-width: ${breakpoints.tablet}) {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const Dropdown = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownToggle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${colors.sealBrown.replace('ff', '')};

  &:hover {
    color: ${colors.russet};
  }
`;

export const DropdownContent = styled.div<{ $isDropdownOpen: boolean }>`
  display: ${(props) => (props.$isDropdownOpen ? 'flex' : 'none')};
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: var(--color-background);
  padding: 1rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  z-index: 1;
`;
